import React, { useState } from "react";
import "./normalize.css";
import "./pricing.css";

const Pricing = (props) => {
  const [isChecked, setIsChecked] = useState();

  const handleChecked = (check) => {
    if (check === true) {
      setIsChecked(check);
    } else {
      setIsChecked(check);
    }
  };

  return (
    <>
      <Header handleChecked={handleChecked} />
      <main className="mainContainer">
        <PlanCards isChecked={isChecked} plans={props.plans} />
      </main>
    </>
  );
};

const Header = (props) => {
  const handleCheckboxChange = (e) => {
    props.handleChecked(e.target.checked);
  };
  return (
    <header className="headerContainer">
      <div className="titleContainer">
        <h1 className="title">Our Pricing</h1>
      </div>
      <div className="toggleBtnContainer">
        <p>Annually</p>
        <label className="switch">
          <input type="checkbox" onChange={handleCheckboxChange} />
          <span className="slider round"></span>
        </label>
        <p>Monthly</p>
      </div>
    </header>
  );
};

const PlanCards = (props) => {
  const plans = props.plans;
  return plans.map((plan) => {
    return (
      <div key={plan.plan} id={plan.plan} className="planContainer">
        <h2 className="planName"> {plan.plan}</h2>
        {props.isChecked ? <span className="planPrice">{plan.priceMonthly}</span> : <span className="planPrice">{plan.priceAnnually}</span>}
        <ul className="benefitContainer">
          <PlanBenefits benefit={plan.storage} />
          <PlanBenefits benefit={plan.users} />
          <PlanBenefits benefit={plan.send} />
        </ul>
        <button className="learnMoreBtn">Learn More</button>
        <div className="learnMoreContainer"></div>
      </div>
    );
  });
};

const PlanBenefits = (props) => {
  return <li className="planBenefits">{props.benefit}</li>;
};

export default Pricing;
